/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ItemDocuments = 'TenderInfoExportExcel' | 'PartialDecisionDocs';

export const ItemDocuments = {
    TenderInfoExportExcel: 'TenderInfoExportExcel' as ItemDocuments,
    PartialDecisionDocs: 'PartialDecisionDocs' as ItemDocuments
};

